export default __webpack_public_path__ + "static/media/project3.f562bf73.jpg";